var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongInfoPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9961 52.9217L22.9211 49.9967H59.9961V19.9967H19.9961V52.9217ZM37.4961 24.9967H42.4961V34.9967H37.4961V24.9967ZM37.4961 39.9967H42.4961V44.9967H37.4961V39.9967Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15H20C17.25 15 15.025 17.25 15.025 20L15 65L25 55H60C62.75 55 65 52.75 65 50V20C65 17.25 62.75 15 60 15ZM60 50H22.925L20 52.925V20H60V50ZM37.5 40H42.5V45H37.5V40ZM37.5 25H42.5V35H37.5V25Z",
    fill: "#E9E7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongInfoPageIcon);
export default __webpack_public_path__ + "static/media/wrong_info_page_icon.3e0c660316e6f720f8ff8a9e29253abf.svg";
export { ForwardRef as ReactComponent };